import { render, staticRenderFns } from "./StopUpdateRequiredModal.vue?vue&type=template&id=5e81779c&"
import script from "./StopUpdateRequiredModal.vue?vue&type=script&lang=js&"
export * from "./StopUpdateRequiredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports